<ub-filter-list *ngIf="sorts$ | async; let sorts">
  <span label i18n>Arrange by:</span>
  <ub-simple-list filters>
    <ub-simple-list-item *ngFor="let sort of sorts">
      <button *ngIf="sort.id !== active" mat-button color="primary" (click)="onSelect(sort)">{{ sort.name }}</button>
      <button *ngIf="sort.id === active" mat-button disabled="true">{{ sort.name }}</button>
    </ub-simple-list-item>
  </ub-simple-list>
</ub-filter-list>
